module.exports = __webpack_public_path__ + "static/bohater_1-136062067aa0a2f0c6c1ff9b9367c261.png";